import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import MyUnitsScrollSaver from './MyUnitsScrollSaver'
import AgentHeader from '../../agentModule/AgentHeader'
import LandlordHeader from '../../landlordModule/LandlordHeader'

import useUserType from '../../../hooks/UseUserType'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux'
import { type RootState } from '../../../store/store'
import UnitsHeaderSh from './UnitsHeaderSh'
import UnitsNavigateSh from './UnitsNavigateSh'
import MainUnitFilters from './filters/MainUnitFilters'
import UnitSh from './UnitSh'
import { nanoid } from 'nanoid'
import UnitsNotFoundMessageSh from './UnitsNotFoundMessageSh'
import { Spin } from 'antd'
import useUnitsCatalog from '../../../hooks/useUnitsCatalog'
import { setPublishedVisibilityFilter, setUnitsCatalogScrollPosition, setUnitsCategory, setUnitsSourceFilter, UnitsCategory, type UnitsSourceFilter } from '../../../store/slices/unitsSlice'
import Loader from '../../../app/custom/loaders/Loader'
import getUserType from '../../../functions/shared/user/getUserType'
import { USER_ID_KEY } from '../../../urls'
import getUnitOfferStatus from '../../../functions/shared/units/getUnitOfferStatus'
import useUnitsNew from '../../../hooks/useUnitsNew'
import useMediaQuery from '../../../hooks/useMediaQuery'
import './MyUnitsWithFiltersDesktop.scss'
const MyUnitsWithFiltersSh = (): JSX.Element => {
    const dispatch = useAppDispatch()
    const { filters: storedFilters, searchString, unitsLoading, units, myArchivedUnitsOpen, myRequestedUnitsOpen, myPublishedUnitsOpen } = useAppSelector((state: RootState) => state.units)
    const { userType, userTypeLowercase } = useUserType()
    const filteredCatalog = useUnitsNew() // useUnitsCatalog(true)
    const unitsCategory = useAppSelector((state: RootState) => state.units.unitsCategory)
    const unitsSourceFilter = useAppSelector((state: RootState) => state.units.unitsSourceFilter)
    const publishedVisibilityFilter = useAppSelector((state: RootState) => state.units.publishedVisibilityFilter)
    const userDevice = useAppSelector((state: RootState) => state.app.userDevice)
    const paginationLoading = useAppSelector((state: RootState) => state.units.catalogLoading)
    const [filterUse, setFilterUse] = useState('rent')
    const currentUser = useAppSelector((state: RootState) => state.user.currentUser)
    const userID = window.localStorage.getItem(USER_ID_KEY) ?? currentUser.id ?? ''
    const isDesktop = useMediaQuery("(min-width: 992px)");
    const { pathname } = useLocation()
    const listScrollRef = useRef<HTMLDivElement>(null)
    const onClickCategory = (val: UnitsCategory): any => {
        dispatch(setUnitsCatalogScrollPosition(0))
        dispatch(setUnitsCategory(val))
    }
    //  console.log({ filters: storedFilters, searchString, unitsLoading, units, myArchivedUnitsOpen, myRequestedUnitsOpen })
    const isMobileCanvas = useMediaQuery('(max-width: 480px)');
    const isDesktopWithSidebar = isDesktop && pathname.startsWith('/landlord')
    const showControls = !(myRequestedUnitsOpen && Number(userID) !== Number(process.env.REACT_APP_BSO_SUPPORT_USER_ID))
    const showSourceFilter = Number(userID) === Number(process.env.REACT_APP_BSO_USER_ID) && (myRequestedUnitsOpen || myPublishedUnitsOpen)
    const sourceFilters: Array<{ label: string, value: UnitsSourceFilter }> = [
        { label: 'All', value: 'all' },
        { label: 'Agent', value: 'agent' },
        { label: 'Landlord', value: 'landlord' }
    ]
    const sourceFilterControls = showSourceFilter && (
        <div className="d-flex flex-wrap align-items-center gap-2 px-4 py-2">
            <span className="text-gray-700 fs-8 fw-semibold text-uppercase me-1">Source</span>
            {sourceFilters.map((option) => (
                <button
                    key={option.value}
                    className={`btn btn-sm ${unitsSourceFilter === option.value ? 'btn-bso' : 'btn-outline btn-outline-default'}`}
                    type="button"
                    onClick={() => dispatch(setUnitsSourceFilter(option.value))}
                >
                    {option.label}
                </button>
            ))}
        </div>
    )
    const publicationFilterControls = Number(userID) === Number(process.env.REACT_APP_BSO_USER_ID) && myPublishedUnitsOpen && (
        <div className="d-flex flex-wrap align-items-center gap-2 px-4 py-2">
            <span className="text-gray-700 fs-8 fw-semibold text-uppercase me-1">Publication</span>
            <button className={`btn btn-sm ${publishedVisibilityFilter === 'catalog' ? 'btn-bso' : 'btn-outline btn-outline-default'}`} type="button" onClick={() => dispatch(setPublishedVisibilityFilter('catalog'))}>Catalog visible</button>
            <button className={`btn btn-sm ${publishedVisibilityFilter === 'operational' ? 'btn-bso' : 'btn-outline btn-outline-default'}`} type="button" onClick={() => dispatch(setPublishedVisibilityFilter('operational'))}>Operational active only</button>
        </div>
    )
    const statisticsNavigation = Number(userID) === Number(process.env.REACT_APP_BSO_USER_ID) && (
        <div className="d-flex justify-content-end px-4 py-2">
            <Link className="btn btn-sm btn-bso" to="/landlord/my_units/statistics">
                BSO Statistics
            </Link>
        </div>
    )

    if (unitsLoading) return <Loader />
    return <>
        <MyUnitsScrollSaver scrollRef={isDesktopWithSidebar ? listScrollRef : undefined} />
        {isDesktopWithSidebar
            ? (
                <div className="page d-flex flex-column flex-row-fluid units-desktop-shell">
                    {/* Checklist: desktop sticky header + list-only scroll + grid; mobile unchanged. */}
                    <div className="units-desktop__header">
                        <div className="units-desktop__header-card">
                            <UnitsHeaderSh />
                            {showControls && (
                                <>
                                    <UnitsNavigateSh filter={{ unitsCategory, filterUse }} onClickCategory={onClickCategory} />
                                    <MainUnitFilters />
                                </>
                            )}
                            {sourceFilterControls}
                            {publicationFilterControls}
                            {statisticsNavigation}
                        </div>
                    </div>
                    <div className="units-desktop__list-scroll" ref={listScrollRef}>
                        {filteredCatalog?.length > 0
                            ? (
                                <div className="units-desktop__grid">
                                    {filteredCatalog.map((unit: any) => {
                                        return (
                                            <UnitSh
                                                key={`${String(unit.id)}`}
                                                hide={true}
                                                unit={unit}
                                                fromEntry={'myUnitsAgent'}
                                            />
                                        )
                                    })}
                                </div>
                            )
                            : (!paginationLoading
                                ? <UnitsNotFoundMessageSh />
                                : <></>
                            )
                        }
                        {paginationLoading
                            ? (
                                <div className={'w-100 d-flex justify-content-center p-4'}>
                                    <Spin size={'large'} />
                                </div>
                            )
                            : <></>
                        }
                    </div>
                </div>
            )
            : (
                <div className="page d-flex flex-column flex-row-fluid">
                    <div style={{ height: "12.5rem" }} />
                    <div className={isMobileCanvas ? "" : "w-100 bg-white h-auto d-flex flex-center shadow-sm mw-600px mx-auto card shadow-sm border-0"}>
                        <div
                            className="position-fixed top-0 start-0 w-100 d-flex justify-content-center units-fixed-in-content"
                            style={{
                                paddingTop: userDevice === "IPhone" ? "2.5rem" : 0,
                                zIndex: 100,
                            }}
                        >
                            <div className="w-100 mw-600px bg-white h-auto fw-bold d-flex flex-column card shadow-sm border-0">
                                <div className="d-flex flex-column p-4 py-0 w-100 position-relative">
                                    <UnitsHeaderSh />
                                </div>

                                {showControls && (
                                    <>
                                        <UnitsNavigateSh filter={{ unitsCategory, filterUse }} onClickCategory={onClickCategory} />
                                        <MainUnitFilters />
                                    </>
                                )}
                                {sourceFilterControls}
                                {publicationFilterControls}
                                {statisticsNavigation}
                            </div>
                        </div>
                        <div className="content d-flex flex-column flex-fill pt-4 pb-4 mx-4 overflow-auto   shadow-sm" style={{ height: "100%" }}>
                            {filteredCatalog?.length > 0
                                ? (
                                    <>
                                        {filteredCatalog.map((unit: any) => {
                                            return (
                                                <UnitSh
                                                    key={`${String(unit.id)}`}
                                                    hide={true}
                                                    unit={unit}
                                                    fromEntry={'myUnitsAgent'}
                                                />
                                            )
                                        })}
                                    </>
                                )
                                : (!paginationLoading
                                    ? <UnitsNotFoundMessageSh />
                                    : <></>
                                )
                            }
                            {paginationLoading
                                ? (
                                    <div className={'w-100 d-flex justify-content-center p-4'}>
                                        <Spin size={'large'} />
                                    </div>
                                )
                                : <></>
                            }
                            <div className="d-none pb-14"></div>
                        </div>
                    </div>
                    <div className="m-0" style={{ height: '170px' }}></div>
                    {!isDesktop && (
                        <div className="fixed-bottom mw-450px mx-auto px-4 py-2 bg-white" style={{ bottom: userDevice === 'IPhone' ? '9.65rem' : '8rem', left: '0px', zIndex: 50 }}>
                            <Link to={`/${userTypeLowercase}/set_unit_modal/set_unit_modal/-/-`}>
                                <div className=" btn btn-bso my-1 fs-6 p-1 py-4 w-100">
                                    Add unit
                                </div >
                            </Link>
                        </div>
                    )}
                </div>
            )
        }
    </>
}

export default MyUnitsWithFiltersSh
